import {Box, Divider, Typography} from "@mui/material";
import React from "react";
import {AudioParamsView, AudioParamsViewProps} from "./AudioParamsView";

export const AudioEditView = ({type, existingAudioPath, text, audioConfig, onChange, isLoading} : AudioParamsViewProps) => {


    return (
        <>
            <Divider textAlign="left">
                <Typography variant="h6">Audio</Typography>
            </Divider>
            <Box sx={{mb: 1}}/>
            <AudioParamsView type={type}
                             text={text}
                             audioConfig={audioConfig}
                             onChange={onChange}
                             existingAudioPath={existingAudioPath}
                             isLoading={isLoading}/>
            <Box sx={{mb: 2}}/>
        </>
    )

}